<template>
    <div>
        <div>
            <div style="display: flex;justify-content: space-between;">
                <div class="questionNums"><span>{{examIndex+1}}</span>/ 共{{questionNum}}题</div>
                	<div>
				<van-count-down  :time="time">
					<template #default="timeData">
						<span class="block">{{ timeData.hours }}</span>
						<span class="colon">:</span>
						<span class="block">{{ timeData.minutes }}</span>
						<span class="colon">:</span>
						<span class="block">{{ timeData.seconds }}</span>
					</template>
				</van-count-down>
			</div>
            </div>
			
           <div>
                <div v-show="examIndex === index ? true :false"  class="option-div" v-for="(questionsItem,index) in questionLists" :key="index">
                    <h2 v-if="questionsItem.type == '001001'" class="questionTitle" ><span>「单选」</span>{{questionsItem.content}}</h2>
                    <h2 v-if="questionsItem.type == '001002'" class="questionTitle" ><span>「多选」</span>{{questionsItem.content}}</h2>
                    <h2 v-if="questionsItem.type == '001003'" class="questionTitle" ><span>「判断」</span>{{questionsItem.content}}</h2>
                    <div class="option-list-radio  cb" v-for="(choicesItem,index) in questionsItem.choices" :key="index">
                        <div v-if="questionsItem.type == '001001'" style="display: flex;align-items: center;">
                        <!-- <el-radio v-model="questionsItem.userAnswer" :label="choicesItem.code" @change="radioChange">
                            <span >{{choicesItem.code}}</span>
                        </el-radio> -->
                            <van-radio v-model="questionsItem.userAnswer" @click="radioChange" :name="choicesItem.code">{{choicesItem.code}}.</van-radio>
                        <div>
                            <span v-html="choicesItem.content" class="exam-words fl"  > </span>
                        </div>
                        </div>
                         <div v-if="questionsItem.type == '001002'" style="display: flex;align-items: center;">
                        <van-checkbox-group v-model="questionsItem.userAnswer">
                            <van-checkbox @click="radioChange" :name="choicesItem.code">{{choicesItem.code}}.</van-checkbox>
                        </van-checkbox-group>
                        <div>
                            <span v-html="choicesItem.content" class="exam-words fl"  > </span>
                        </div>
                        </div>
                         <div v-if="questionsItem.type == '001003'" style="display: flex;align-items: center;">
                            <van-radio v-model="questionsItem.userAnswer" @click="radioChange" :name="choicesItem.code">{{choicesItem.code}}.</van-radio>
                        <div>
                            <span v-html="choicesItem.content" class="exam-words fl"  > </span>
                        </div>
                        </div>
                    </div>
                </div>
            </div>
		</div>
		<div>
            <div>
  <van-cell v-if="!show"  class="examFooters">
                <a javascript: style="color: #2E56D5;" @click="submitExam()">交卷</a>
                <van-button class="questionbtn"  @click="lastQuestion"  plain type="danger">上一题</van-button>
                <van-button class="questionbtn" @click="nextQuestion" plain type="danger">下一题</van-button>
                <a javascript: @click="showPopup"><img src="../../../static/images/mobile/answerSheet.png" alt=""> {{examIndex+1}}/{{questionNum}}</a>
            </van-cell>
			<van-popup   v-model="show"  :overlay="false" position="bottom"  >
                <van-cell class="examFooter">
                <a javascript: style="color: #2E56D5;" @click="submitExam()">交卷</a>
                <van-button class="questionbtn"  @click="lastQuestion"  plain type="danger">上一题</van-button>
                <van-button class="questionbtn" @click="nextQuestion" plain type="danger">下一题</van-button>
                <a javascript: @click="showPopup"><img src="../../../static/images/mobile/answerSheet.png" alt=""> {{examIndex+1}}/{{questionNum}}</a>
            </van-cell>
                <van-button :class="[index === examIndex ? 'active1' : '',{unanswered: typeof(item.userAnswer)!='undefined' && item.userAnswer.length!=0
}]" class="questionAnswer" @click="selecteQuestion(index)" v-for="(item,index) in questionLists" :key="index" plain type="danger">{{index+1}}</van-button>
            </van-popup>
            </div>
			
		</div>
	</div>
</template>
<style scoped>
.active1 {
	border: 1px red solid !important;
}
.questionNums {
	margin-top: 0.693333rem;
	margin-left: 0.426667rem;
}
.questionNums span {
	font-size: 0.426667rem;
	font-weight: bold;
	width: 0.533333rem;
	border-bottom: 0.106667rem #dc0021 solid;
}
.block {
	color: #dc0021;
}
.van-count-down {
	margin-top: 0.693333rem;
	margin-right: 0.426667rem;
	color: #dc0021;
	font-size: 0.373333rem;
}
.examFooters {
	/* 方法一 */
	position: fixed;
	bottom: 0;
	border: 1px solid #dfdede;
}
.exam-words {
	font-weight: 600;
	font-size: 0.373333rem;
	color: #000000;
}
.van-popup {
	border: 1px solid #dfdede;
}
.van-popup .van-button {
	border-radius: 50%;
	height: 0.96rem;
	width: 0.96rem;
	margin: 0.32rem 0.32rem 0.32rem 0.32rem;
}
.van-cell__value {
	display: flex;
	justify-content: space-between;
	align-items: center;
}
.questionbtn {
	border-radius: 0.426667rem !important;
	height: 0.853333rem !important;
	width: 2.346667rem !important;
}
.examFooter a img {
	width: 0.426667rem;
	height: 0.426667rem;
}
.examFooters a img {
	width: 0.426667rem;
	height: 0.426667rem;
}
.examFooters .questionbtn {
	border-radius: 0.426667rem;
	height: 0.853333rem;
	width: 2.346667rem;
}
.questionTitle {
	color: #000000;
	font-size: 0.426667rem;
	font-weight: 400;
	margin: 0.506667rem 0.426667rem 0.64rem 0.426667rem;
}
.questionTitle span {
	color: #2e56d5;
}
.option-list-radio {
	margin-left: 0.426667rem;
	margin-bottom: 0.64rem;
}
.questionAnswer {
	color: #000000;
	background: #f3f3f5;
	border: none;
}
.unanswered {
	background: #fff0f2;
	color: #dc0021;
}
.examFooter {
	position: initial;
}
</style>
<script>
import vueQr from "vue-qr";
import ft from "../Footer";
import headTop from "../Top";
import "../../../static/css/exam-content.css";
import { Dialog } from "vant";
import { Toast } from "vant";
//全局对象 ... 结束时一定要清除.
let FREQUENCY_TIMER;

export default {
	data() {
		return {
			showContent: "",
			show: false,
			time: "",
			questionNum: "",
			examIndex: 0,
			tip: null,
			ifExamTakePhoto: "",
			ifLoseFocusAutoSubmitPaper: "",
			timer: "",
			platformId: "",
			captureTheTiming: "",
			imageUrl: "",
			dialogVisible: false,
			codeUrl: "",
			examinationId: "",
			showCodeTip: false,
			examIntervalId: "",
			scanIntervalId: "",
			uuid: "",
			windowindex: "",
			intervalId: 0,
			count: 0,
			examPaperList: {},
			questionTypeSummaries: [],
			questionList1: [],
			questionList2: [],
			questionList3: [],
			questionDescription: [],
			type: "001001",
			types: "001001",
			questonType: "",
			realName: "",
			userHeadImagUrl: "",
			//考试时长 (分钟)
			duration: null,
			//考试剩余时间
			remainingTime: null,
			//考试开始时间
			startTime: 0,
			//考试结束时间
			endTime: 0,
			//当前时间
			currentTime: 0,
		};
	},
	methods: {
		//切换题目
		selecteQuestion(index) {
			this.examIndex = index;
		},
		radioChange() {
			this.$forceUpdate();
		},
		//下一题
		nextQuestion() {
			if (this.examIndex+2 > this.questionNum) {
				return false;
			} else {
				this.examIndex++;
			}
		},
		//上一题
		lastQuestion() {
			if (this.examIndex < 1) {
				return false;
			} else {
				this.examIndex--;
			}
		},
		//弹层
		showPopup() {
			this.show = !this.show;
		},
		/**
		 * 获取二维码
		 * @param id
		 */
		getQrCode(captureTheTiming, tokenType, examinationId, userId) {
			this.captureTheTiming = captureTheTiming;
			var param = {
				tokenType: tokenType,
				userId: userId,
				examId: examinationId,
			};

			this.$axiosPackag.getMessageByAxios(
				"POST",
				"/web/qrCode/createToken",
				null,
				param,
				{ "Content-Type": "application/json" },
				(resD) => {
					this.showCodeTip = false;
					this.uuid = resD.uuid;
					this.codeUrl = resD.url;
					this.dialogVisible = true;
					this.closeTiming();
					this.examIntervalId = window.setInterval(() => {
						this.getTokenStatus();
					}, 2000);
					this.scanIntervalId = window.setInterval(() => {
						this.getScanStatus();
					}, 2000);
				},
				(errorCall) => {}
			);
		},
		//查询人脸识别是否成功
		getTokenStatus() {
			this.$api.get("/web/qrCode/getTokenInfo", { uuid: this.uuid }, (data) => {
				if (data.status == 0) {
					if (data.data) {
						if (data.data.status == 1) {
							//验证完成清空定时器
							this.stopQuartz();
							this.dialogVisible = false;
							this.$message.success("识别成功");
							if (this.captureTheTiming == "start") {
							} else if (this.captureTheTiming == "end") {
								this.tip = "已交卷";
								this.saveExam();
							} else if (this.captureTheTiming == "middle") {
								clearTimeout(this.timer);
							}
						}
					} else {
						this.stopQuartz();
						this.showCodeTip = true;
					}
				} else {
					this.stopQuartz();
					this.showCodeTip = true;
				}
			});
		},

		//查询扫描二维码是否成功
		getScanStatus() {
			this.$api.get("/web/qrCode/getTokenInfo", { uuid: this.uuid }, (data) => {
				if (data.status == 0) {
					if (data.data) {
						if (data.data.scanStatus == 1) {
							//验证完成清空定时器
							window.clearInterval(this.scanIntervalId);
							this.$message.success("扫码成功");
						}
					} else {
						this.stopQuartz();
						this.showCodeTip = true;
					}
				}
			});
		},

		stopQuartz() {
			window.clearInterval(this.examIntervalId);
			window.clearInterval(this.scanIntervalId);
		},
		perconCommit() {
			this.tip = "已交卷";
			this.autoCommit();
		},
		/**
		 * 倒计时结束了,自动提交试卷
		 */
		autoCommit() {
			window.clearInterval(this.intervalId);
			this.submitExam(true);
		},
		packageSaveAnswer() {
			let answerData = [];
			for (var i = 0; i < this.questionList1.length; i++) {
				if (this.questionList1[i].userAnswer) {
					answerData.push({
						id: this.questionList1[i].id,
						userAnswer: this.questionList1[i].userAnswer,
					});
				}
			}
			for (var i = 0; i < this.questionList2.length; i++) {
				if (this.questionList2[i].userAnswer.length > 0) {
					answerData.push({
						id: this.questionList2[i].id,
						userAnswer: this.questionList2[i].userAnswer.join(","),
					});
				}
				// debugger
			}
			for (var i = 0; i < this.questionList3.length; i++) {
				if (this.questionList3[i].userAnswer) {
					answerData.push({
						id: this.questionList3[i].id,
						userAnswer: this.questionList3[i].userAnswer,
					});
				}
			}
			return answerData;
		},
		saveExam(isAuto) {
			//如果是自动交卷 ...直接设置为考试结束...否则的话 ,允许手动提交.
			if (isAuto) {
				this.examIsEnd = true;
			}
			let allAnswerNumber = 0,
				hasAnswerNume = 0,
				unAnswerNumber = 0;
			for (var i = 0; i < this.questionList1.length; i++) {
				if (this.questionList1[i].userAnswer) {
					hasAnswerNume++;
				} else {
					unAnswerNumber++;
				}
				allAnswerNumber++;
			}
			for (var i = 0; i < this.questionList2.length; i++) {
				if (this.questionList2[i].userAnswer.length > 0) {
					hasAnswerNume++;
				} else {
					unAnswerNumber++;
				}
				allAnswerNumber++;
			}
			for (var i = 0; i < this.questionList3.length; i++) {
				if (this.questionList3[i].userAnswer) {
					hasAnswerNume++;
				} else {
					unAnswerNumber++;
				}
				allAnswerNumber++;
			}

			// if (unAnswerNumber > 0) {
			// 	Dialog.confirm({
			// 		title: "确认",
			// 		message: "还未完成全部题目，是否确定交卷",
			// 	})
			// 		.then(() => {
			// 			this.submitConfirme();
			// 		})
			// 		.catch(() => {});
			// } else {
			// 	Dialog.confirm({
			// 		title: "确认",
			// 		message: "已完成全部题目，是否确定交卷",
			// 	})
			// 		.then(() => {
			// 			this.submitConfirme();
			// 		})
			// 		.catch(() => {});
			// }
		},
		/**
		 * 提交试卷
		 */
		submitExam(isAuto, str) {
			if (!this.$util.isBlackStr(str)) {
				this.tip = str;
			}
			if (isAuto) {
				this.submitConfirme();
			} else {
				if (this.ifExamTakePhoto == "1") {
					this.getQrCode("end", "004", this.examId, this.$sessionStore.getUserId());
				} else {
					this.submitConfirme();
				}
			}
		},

		/**
		 *确定提交
		 */
		submitConfirme() {
			this.backSendUserAnswer();
			let answerData = this.packageSaveAnswer();
			//没有任何答题记录
			//   if (answerData.length <= 0) {
			//     this.$confirm('您没有作答', '提示')
			//     return;
			//   }
			var param = {
				recordId: this.examPaperList.recordId,
				answerData: JSON.stringify(answerData),
			};
			this.$axiosPackag.getMessageByAxios(
				"POST",
				"/api/student/onlineExam/submit",
				param,
				null,
				null,
				(resD) => {
					Toast("已交卷");
					this.$router.push({ path: "/mobileExamAnalysis" , query: { id: this.examPaperList.recordId }});
				},
				(errorD) => {
				}
			);
		},
		/**
		 * 定时保存,该用户的答题记录
		 */
		intervalTimer() {
			//清除之前的定时器
			clearInterval(FREQUENCY_TIMER);
			FREQUENCY_TIMER = setInterval(() => {
				this.backSendUserAnswer();
			}, 5 * 60 * 1000);
		},
		/**
		 *定时发送,当前考试的数据包
		 */
		backSendUserAnswer() {
			let answerData = this.packageSaveAnswer();
			//没有任何答题记录
			if (answerData.length <= 0) {
				return;
			}
			var param = {
				recordId: this.examPaperList.recordId,
				answerData: JSON.stringify(answerData),
			};
			this.$axiosPackag.getMessageByAxios(
				"POST",
				"/api/student/onlineExam/saveAnswer",
				param,
				null,
				null,
				(resD) => {},
				(errorD) => {}
			);
		},
		/**
		 * 鼠标离开页面后10秒或者离开5次自动交卷
		 */
		timing() {
			this.count++;
			console.info(this.count);
			if (this.count > 5) {
				this.tip = "光标失去焦点大于5次已自动交卷";
				this.autoCommit();
				return;
			}
			console.info("触发定时");
			window.clearInterval(this.intervalId);
			this.intervalId = setInterval(this.autoCommit, 10000);
		},
		/**
		 * 关闭定时
		 */
		closeTiming() {
			console.info("清除");
			window.clearInterval(this.intervalId);
		},
		examPaperData() {
			this.$axiosPackag.getMessageByAxios("GET", "/api/student/onlineExam/enterExamination", { id: this.examId }, null, null, (res) => {
				this.examPaperList = res;
				this.questionTypeSummaries = res.questionTypeSummaries;
				//考试总时长  分钟
				this.duration = parseInt(res.duration);
				//剩余时长   毫秒级别
				this.time = res.remainingTime;
				// this.remainingTime = res.remainingTime;
				if (this.ifExamTakePhoto == "1") {
					let openCodeTime = this.remainingTime / 2;
					this.timer = setTimeout(this.openQrcode, openCodeTime);
				}
				//直接调用开始考试
				this.beginExam();
				for (var i = 0; i < this.questionTypeSummaries.length; i++) {
					for (var j = 0; j < this.questionTypeSummaries[i].questions.length; j++) {
						var question = this.questionTypeSummaries[i].questions[j];
						question.content = this.$util.html(question.content);
						question.analysis = this.$util.html(question.analysis);
						question.answer = this.$util.html(question.answer);
						if (question.choices) {
							for (var q = 0; q < question.choices.length; q++) {
								question.choices[q].content = this.$util.html(question.choices[q].content);
							}
						}
						if (question.blanksNumber) {
							let blanksNumber = parseInt(question.blanksNumber);
							question.blanksNumbers = [];
							for (let f = 0; f < blanksNumber; f++) {
								let op = {};
								op.userAnswer = [];
								question.blanksNumbers.push(op);
							}
						}
						if (question.type == "001001") {
							this.questionList1.push(question);
						} else if (question.type == "001002") {
							// debugger
							question.userAnswer = question.userAnswer ? question.userAnswer.split(",") : [];
							this.questionList2.push(question);
						} else if (question.type == "001003") {
							this.questionList3.push(question);
						}
						const a = this.questionList1;
						const b = this.questionList2;
						const c = this.questionList3;
						const d = [...a, ...b, ...c];
						this.questionLists = d;
						this.questionNum = this.questionLists.length;
						this.questionDescription[question.type] = this.questionTypeSummaries[i].description;
					}
				}
			});
		},
		handleCheckedCitiesChange(value) {
			for (var i = 0; i < this.questionList2.length; i++) {
				this.$set(this.questionList2, i, this.questionList2[i]);
			}

			// debugger
		},
		menuBtn(type) {
			this.type = type;
		},
		menuBtns(types) {
			this.types = types;
		},
		/**
		 *开始考试按钮
		 */
		beginExam() {
			let sumTime = 0;
			if (this.remainingTime) {
				//此处是毫秒值
				sumTime = parseInt(this.remainingTime);
			} else {
				sumTime = parseInt(this.duration) * 60 * 1000;
			}
			this.startTime = new Date().getTime();
			this.endTime = this.startTime + sumTime;
			this.currentTime = this.startTime;
			this.intervalTimer();
		},
		refreshCode() {
			this.getQrCode(null, "004", this.examId, this.$sessionStore.getUserId());
		},
		openQrcode() {
			this.getQrCode("middle", "004", this.examId, this.$sessionStore.getUserId());
		},
	},
	components: {
		vueQr,
		headTop,
		ft,
	},
	mounted() {
		this.examId = this.$route.query.id;
		this.ifExamTakePhoto = this.$route.query.ifExamTakePhoto;
		//是否考试抓拍
		if (this.ifExamTakePhoto == "1") {
			this.getQrCode("start", "004", this.examId, this.$sessionStore.getUserId());
		}
		//是否失去焦点自动交卷
		if (this.ifLoseFocusAutoSubmitPaper == "1") {
			window.addEventListener("blur", (e) => this.timing(e), false);
			window.addEventListener("focus", (e) => this.closeTiming(e), false);
		}
		this.examPaperData();
	},
	destroyed() {
		if (this.ifLoseFocusAutoSubmitPaper == "1") {
			window.removeEventListener("blur", (e) => this.timing(e), false);
			window.removeEventListener("focus", (e) => this.closeTiming(e), false);
		}
	},
};
</script>
<style scoped>
.el-checkbox-group span {
	color: #666 !important;
	font-size: 14px;
	font-family: "宋体";
}

.qrCodeClass .showCodeTip {
	top: 19px;
	left: 43px;
	background: #fff;
	width: 200px;
	height: 200px;
}
.qrCodeClass .qrcodeTip {
	color: #333;
}
</style>



// WEBPACK FOOTER //
// MobileExam.vue?5316e0f6